export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
            <div>
              <span className="font-heading text-2xl text-primary-400">虫虫动漫</span>
              <p className="mt-3 text-sm text-background-400 leading-relaxed">
                虫虫动漫是领先的免费漫画与免费看漫画在线平台，提供海量免费动漫全集在线阅读服务。下拉式滚动浏览，无需付费轻松畅享，致力于打造最优质的免费漫画网站大全。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-lg text-background-100 mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                {[
                  { label: '热门话题', href: '#topics' },
                  { label: '精彩推荐', href: '#cards' },
                  { label: '热度榜单', href: '#ranking' },
                  { label: '更新动态', href: '#updates' },
                  { label: '常见问答', href: '#faq' },
                ].map((item) => (
                  <li key={item.href}>
                    <a
                      href={item.href}
                      onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-lg text-background-100 mb-4">漫画分类</h4>
              <ul className="space-y-2.5">
                {['热血格斗', '恋爱校园', '悬疑推理', '异世界', '搞笑日常', '少女言情', '科幻未来'].map((cat) => (
                  <li key={cat}>
                    <a
                      href="#index"
                      onClick={(e) => { e.preventDefault(); handleNavClick('#index'); }}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200"
                    >
                      {cat}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-lg text-background-100 mb-4">合作伙伴</h4>
              <p className="text-sm text-background-500 leading-relaxed">
                与优质漫画平台和内容创作者合作，持续为用户提供丰富的免费漫画阅读资源。
              </p>
              <div className="mt-4">
                <a
                  href="#contact"
                  onClick={(e) => { e.preventDefault(); handleNavClick('#contact'); }}
                  className="inline-flex items-center gap-1.5 text-sm text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap"
                >
                  <span>商务合作</span>
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 虫虫动漫 - 免费漫画在线平台. 仅供阅读交流，请支持正版.
            </p>
            <div className="flex items-center gap-5">
              <a href="#hero" onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }} className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">回到顶部</a>
              <a href="#faq" onClick={(e) => { e.preventDefault(); handleNavClick('#faq'); }} className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">帮助中心</a>
              <a href="#contact" onClick={(e) => { e.preventDefault(); handleNavClick('#contact'); }} className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">联系我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}